import ReactSelect from 'react-select';

const SelectInputFormik = ({
  title,
  options,
  id,
  name,
  handleChange,
  errors,
  touched,
  ...props
}) => {
  return (
    <div className='flex flex-col gap-1'>
      <label htmlFor={id} className='max-lg:text-sm'>
        {title} {props?.mandatory && <span className='text-red-600'>*</span>}
      </label>
      <ReactSelect
        name={name}
        id={id}
        placeholder=''
        onChange={handleChange}
        options={options}
        classNamePrefix='react-select'
        styles={customStyles}
        {...props}
      />
      {errors[name] && touched[name] ? (
        <p className='mt-1 text-xs text-red-500 sm:text-sm'>{errors[name]}</p>
      ) : null}
    </div>
  );
};

export default SelectInputFormik;

export const customStyles = {
  control: (provided) => ({
    ...provided,
    boxShadow: 'none',
    padding: '0.2rem',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'none',
    },
    border: '1px solid #cbd5e1',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f00909' : 'white',
    color: state.isFocused ? 'white' : 'black',

    border: 'none',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#f00909',
      color: 'white',
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderColor: 'white',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  }),
};
